import ReactPixel from 'react-facebook-pixel';

const options = {
  autoConfig: true, // set pixel's autoConfig. More info: https://developers.facebook.com/docs/facebook-pixel/advanced/
  debug: false, // enable logs
};

class FB2 {
  constructor(email) {
    this.pixel = ReactPixel;
    let gtmLocationData = JSON.parse(localStorage.getItem("gtmLocationData"));

    this.pixel.init(
      process.env.NEXT_PUBLIC_FACEBOOK_PIXEL_ID_WITHOUT_CONTRACT_TRACKING,
      {
        em: email,
        ct: gtmLocationData?.city,
        st: gtmLocationData?.region,
        zp: gtmLocationData?.postal,
        country: gtmLocationData?.country,
      }, options
    );

    this.pixel.pageView();

  }

  trackPurchase(product, priceId, quantity, value) {
    console.log(product, priceId, quantity, value)
    this.pixel.track('Purchase', {
      value: value,
      num_items: quantity,
      currency: 'USD',
      content_ids: [priceId],
      content_name: product,
    });


  }

  trackInitiateCheckout(product, priceId, quantity, value,) {
    console.log(product, priceId, quantity, value)
    this.pixel.track('InitiateCheckout', {
      value: value,
      num_items: quantity,
      currency: 'USD',
      content_category: product,
      content_ids: [priceId],

    });


  }


  trackAddPaymentInfo(product, priceId, quantity, value) {
    console.log(product, priceId, quantity, value)
    this.pixel.track('AddPaymentInfo', {
      value: value,
      num_items: quantity,
      currency: 'USD',
      content_category: product,
      content_ids: [priceId],

    });

    is.linkedin.trackAddPaymentInfo(product, priceId, quantity, value)


  }


  trackCustom(event, data) {
    this.pixel.track(event, data);

  }



  trackSignUp(email, value) {
    this.pixel.track('StartTrial', {
      currency: 'USD',
      value: value ?? 99,
      predicted_ltv: 250,
    })
  }

}


export default FB2
